<template>
    <div id="configuration-content" class="px-6">
        <template>
            <div slot="header" class="flex justify-between py-6">
                <h4 class="font-bold">Configuration</h4>
            </div>

            <vs-tabs :color="colorx" class="staff-tab-content" style="background: #fff;" v-model="active_tab" :key="tab_key">
                <vs-tab @click="colorx = 'primary'" label="Commission">
                    <div class="con-tab-ejemplo">
                        <commission-content @OutConfiguration="outConfiguration" @SaveCommission="saveCommission" :commissionList="commissionList"></commission-content>
                        <!-- <staff-info :activeStaffData="activeStaffData" @EditStaff="editStaff" @ChangeStaffStatus="changeStaffStatus" :key="activeStaffData.user_id" :filter="filter" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @EditCommission="editCommission"></staff-info> -->
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'primary'" label="Salary + Commission">
                    <div class="con-tab-ejemplo">
                        <salary-commission-content @OutConfiguration="outConfiguration" @SaveSalaryCommission="saveCommission" :commissionList="commissionList"></salary-commission-content>
                            <!-- <staff-service v-if="serviceData.length != 0" :activeStaffData="activeStaffData" :serviceData="serviceData" :staffServiceData="staffServiceData" @AddStaffService="addStaffService" @DeleteStaffService="deleteStaffService"></staff-service>
                            <div v-if="serviceData.length == 0" class="text-center">No data Available</div> -->
                    </div>
                </vs-tab>
                <vs-tab @click="colorx = 'primary'" label="Salary">
                    <div class="con-tab-ejemplo">
                        <salary-content @OutConfiguration="outConfiguration" @SaveSalary="saveCommission" :commissionList="commissionList"></salary-content>
                        <!-- <working-hour :workingHourData="workingHourData" :activeStaffData="activeStaffData" @SaveWorkingHour="saveWorkingHour"></working-hour> -->
                    </div>
                </vs-tab>
            </vs-tabs>
        </template>
    </div>
</template>

<script>
export default {
    name: 'configuration-content',
    props: {
      activeStaffData: {
        type: Object,
        required: true
      }
    },
    data() {
        return {
            colorx: 'primary',
            active_tab: 0,
            tab_key: 0
        }
    },
    watch: {
      activeStaffData: {
        immediate: true,
        deep: true,
        handler() {
          if(this.activeStaffData) {
            if(this.activeStaffData.commission_type == 'commission') {
              this.active_tab = 0;
            } else if(this.activeStaffData.commission_type == 'salary') {
              this.active_tab = 2;
            } else {
              this.active_tab = 1;
            }
            this.tab_key++;
          }
        }
      }
    },
    methods: {
        openLoadingInDiv() {
          this.$vs.loading({
            container: "#configuration-content",
            scale: 0.8
          });
          if (this.loadTime) {
            clearTimeout(this.loadTime);
            this.loadTime = null;
          }
          this.isOpenLoading = true;
          this.loadTime = setTimeout(() => {
            if (this.isOpenLoading) {
              this.closeLoading();
              this.$vs.dialog({
                color: "danger",
                title: "Notification",
                text: "Update commission failed",
                acceptText: "OK"
              });
            }
          }, 10000);
        },
        closeLoading() {
          this.$vs.loading.close("#staff-list > .con-vs-loading");
          this.isOpenLoading = false;
        },
        saveCommission(data){
          data.staff_id = this.activeStaffData.user_id
          const staff_data = JSON.parse(JSON.stringify(this.activeStaffData));
          staff_data.commission_type = data.type;
          // this.$store.dispatch("staffList/UPDATE_COMMISION", data).then(() => {
          //   this.closeLoading();
          //   this.popupActive = false;
          //   const staff_data = JSON.parse(JSON.stringify(this.activeStaffData));
          //   staff_data.status = !this.status ? 1 : 0;
          //   this.$emit("ChangeStaffStatus", staff_data);
          //   this.$vs.notify({
          //     title: "Notification",
          //     text: "Update Commission Success",
          //     color: "success",
          //     position: "top-right"
          //   });
          // })
          // .catch(() => {
          //   this.closeLoading();
          //   this.$vs.notify({
          //     title: "Notification",
          //     text: "Update Commission Fail",
          //     color: "danger",
          //     position: "top-right"
          //   });
          // })
          this.$emit("UpdateStaff", staff_data)
          this.$emit("SaveCommission", data)
          this.$emit("OutConfiguration");
        },
        outConfiguration() {
            this.$emit('OutConfiguration');
        }
    },
    computed:{
        commissionList(){
          return this.$store.getters["staffList/commissionList"];
        },
        config(){
          return this.$store.getters['auth/config'];
        }
    },
    created(){
      const obj = {
        staff_id : this.activeStaffData.user_id
      }
      if(this.config && this.config.pos_feature == 1) {
        this.$store.dispatch("staffList/LIST_COMMISSION_BY_STAFF", obj)
      }
    }
}
</script>
